import { connect } from "react-redux";

import actions from "../../actions";
import ScheduleRightRowChita from "../../components/list/ScheduleRightRowChita";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItem: (data, handleSuccess, handleCancel) =>
      dispatch(actions.schedule_chita.updateItem(data, handleSuccess, handleCancel)),
    showAlert: (title, messages, okClickHandler) => dispatch(actions.app.showAlert(title, messages, okClickHandler)),
    hideAlert: () => dispatch(actions.app.hideAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleRightRowChita);
